module.exports = __webpack_public_path__ + "img/144.5a099bfc.jpg";